export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_POSSIBILITIES = 'SET_POSSIBILITIES'